function parseSubnavItems(items, root = 0) {
  if (!items || !Array.isArray(items) || items.length === 0) {
    return [];
  }
  return items.filter((item) => {
    const itemParent = parseInt(item.parent.toString(), 10);
    const rootParent = parseInt(root.toString(), 10);
    return itemParent === rootParent;
  }).map((menuItem) => {
    var _a, _b;
    const title = typeof menuItem.title === "string" ? menuItem.title : ((_a = menuItem.title) == null ? void 0 : _a.rendered) || ((_b = menuItem.title) == null ? void 0 : _b.raw) || "";
    const id = parseInt(menuItem.id.toString(), 10);
    const parent = parseInt(menuItem.parent.toString(), 10);
    const children = parseSubnavItems(items, id);
    return {
      id,
      title,
      url: menuItem.url,
      parent,
      ...children.length > 0 && {
        children
      }
    };
  });
}
export {
  parseSubnavItems
};
